import React from "react";
import { Icon, Panel, Tooltip, Grid, classnames } from "@culturehq/components";

import { GetState } from "app/hooks/useGet";
import { formatThousand, t, Trans } from "app/utils";

import styles from "./event-status.module.scss";
import Change from "./Change";

type UsersStats = {
  total: number;
  change: number;
};

const ActiveUsers: React.FC<{ users: UsersStats }> = ({ users }) => (
  <Panel>
    <Panel.Body className="tile_view">
      <div className={classnames(styles.icon, styles.green)}>
        <Icon icon="ios-people-outline" />
      </div>
      <h2>{formatThousand(users.total)}</h2>
      <div>
        <h4><Trans>Active Users</Trans></h4>
      </div>
      <Change change={users.change} />
    </Panel.Body>
  </Panel>
);

type StoriesStats = {
  total: number;
  change: number;
};

const TotalStories: React.FC<{ stories: StoriesStats }> = ({ stories }) => (
  <Panel>
    <Panel.Body className="tile_view">
      <div className={classnames(styles.icon, styles.blue)}>
        <Icon icon="book" />
      </div>
      <h2>{formatThousand(stories.total)}</h2>
      <div>
        <h4><Trans>Total Stories</Trans></h4>
      </div>
      <Change change={stories.change} />
    </Panel.Body>
  </Panel>
);

type TotalEngagementStats = {
  total: number;
  change: number;
};

const TotalEngagement: React.FC<{ engagement: TotalEngagementStats }> = ({ engagement }) => (
  <Panel>
    <Panel.Body className="tile_view">
      <div className={classnames(styles.icon, styles.yellow)}>
        <Icon icon="linkedin-thumbsup" />
      </div>
      <h2>{formatThousand(engagement.total)}</h2>
      <div className="card_infoicn">
        <h4 className="m-r-5">
          <Trans>Total Engagement</Trans>
        </h4>
        <Tooltip tip={t("This value is the number of cheers and comments for the stories.")}>
          <Icon icon="info" />
        </Tooltip>
      </div>
      <Change change={engagement.change} />
    </Panel.Body>
  </Panel>
);

const InternalStatusGetting: React.FC = () => (
  <Grid>
    <Grid.Item md={6} lg={4}>
      <Panel>
        <Panel.LoaderBody loading className="tile_view" />
      </Panel>
    </Grid.Item>
    <Grid.Item md={6} lg={4}>
      <Panel>
        <Panel.LoaderBody loading className="tile_view" />
      </Panel>
    </Grid.Item>
    <Grid.Item md={12} lg={4}>
      <Panel>
        <Panel.LoaderBody loading className="tile_view" />
      </Panel>
    </Grid.Item>
  </Grid>
);

type InternalStats = {
  stats: {
    stories: StoriesStats;
    users: UsersStats;
    engagement: TotalEngagementStats;
  };
};

type InternalStatusProps = {
  get: GetState<InternalStats>;
};

const InternalStatus: React.FC<InternalStatusProps> = ({ get }) => {
  if (get.getting) {
    return <InternalStatusGetting />;
  }

  if (get.error) {
    throw get.error;
  }

  return (
    <Grid>
      <Grid.Item md={6} lg={4}>
        <ActiveUsers users={get.got.stats.users} />
      </Grid.Item>
      <Grid.Item md={6} lg={4}>
        <TotalStories stories={get.got.stats.stories} />
      </Grid.Item>
      <Grid.Item md={12} lg={4}>
        <TotalEngagement engagement={get.got.stats.engagement} />
      </Grid.Item>
    </Grid>
  );
};

export default InternalStatus;
